export default "__VITE_ASSET__BVT_lm$5__"